import { Routes } from "@blitzjs/next"
import MakeItRain from "app/core/components/animation/MakeItRain"
import { SButton } from "@superwall-me/sui"
import Head from "next/head"
import Image from "next/legacy/image"
import { useRouter } from "next/router"
import Logo from "public/SuperwallLogo.svg"
import { FC, PropsWithChildren, useState } from "react"
import useLogout from "../hooks/useLogout"
import { getLoginRoute, useSession } from "app/authv2/use-session"

const ErrorLayout: FC<PropsWithChildren<{ title?: string; statusCode?: number }>> = ({
  title,
  statusCode,
  children,
}) => {
  const logout = useLogout()
  const { isLoading, isLoggedIn } = useSession()
  const router = useRouter()
  const [loggingOut, setLoggingOut] = useState(false)

  return (
    <>
      <Head>
        <title>{statusCode && title ? `${statusCode}: ${title}` : `Error`}</title>
      </Head>
      <main className={`dark:bg-grayscale-darkest flex flex-grow`}>
        <MakeItRain />
        <div className="m-auto justify-center w-3/5 lg:w-1/4">
          <div className="text-center mb-12">
            <div className="text-center mb-6">
              <div className="mb-10 flex justify-center">
                <div style={{ width: "62%" }}>
                  <Image alt={"logo"} layout="responsive" src={Logo} />
                </div>
              </div>
            </div>
            {children}
            {!loggingOut ? (
              <div className={"flex justify-center"}>
                <SButton
                  className={`mt-2`}
                  onClick={async () => {
                    window.history.back()
                  }}
                >
                  Go Back
                </SButton>
              </div>
            ) : null}

            <div className={`fixed right-2 top-2 `}>
              {!isLoading && !loggingOut ? (
                <>
                  {isLoggedIn ? (
                    <div>
                      <SButton
                        onClick={async () => {
                          await logout()
                          router.push(getLoginRoute())
                          setLoggingOut(true)
                        }}
                      >
                        Logout
                      </SButton>
                    </div>
                  ) : (
                    <SButton
                      onClick={async () => {
                        router.push(getLoginRoute())
                      }}
                    >
                      Log In
                    </SButton>
                  )}
                </>
              ) : undefined}
            </div>
          </div>
        </div>
      </main>
    </>
  )
}

export default ErrorLayout
